import { CreateNote, NoteSearch, NoteBundle, NoteUpdate } from '@quromedical/models';
import { trpc } from 'trpc';

export class NotesApi {
  public async getNotes(params: NoteSearch): Promise<NoteBundle> {
    const result = await trpc.client.patient.getNotes.query(params);
    const { link, notes, pins } = result;

    return {
      link,
      notes,
      pins,
    };
  }

  public async updateNote(params: NoteUpdate) {
    await trpc.client.patient.noteUpdate.mutate({
      ...params,
    });
  }

  public async createNote(body: CreateNote) {
    await trpc.client.patient.createNote.mutate(body);
  }

  public async pinNote(params: NoteUpdate) {
    await trpc.client.patient.noteUpdate.mutate({
      ...params,
    });
  }
}
